import { useEffect } from "react";
import "@/App.css";

function App() {
  useEffect(() => {
    window.location.replace("/api/");
  }, []);

  return (
    <div
      data-testid="redirect-loading"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1A1A4E 0%, #6B3FA0 100%)",
        color: "#FFD700",
        fontFamily: "'Noto Serif', serif",
        fontSize: "1.2rem",
      }}
    >
      Μεταφορά στο Πανταχού Παρών…
    </div>
  );
}

export default App;
